import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// User Model
import Vue from 'vue';
import VuexORM from '@vuex-orm/core';
import moment from 'moment';
import Project from "./Project";
import Account from "./Account";
import User from "./User";
import Phase from "./Phase";
import Entry from "./Entry";
import Tag from 'src/store/models/Tag';
import TimerTag from 'src/store/models/TimerTag';
import Todo from 'src/store/models/Todo';

var Timer = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Timer, _VuexORM$Model);

  var _super = _createSuper(Timer);

  function Timer() {
    _classCallCheck(this, Timer);

    return _super.apply(this, arguments);
  }

  _createClass(Timer, [{
    key: "$toggleStatus",
    value: function $toggleStatus() {
      var _this = this;

      return Timer.api().put('/timers/' + this.timer_id, {
        timer_status: this.timer_status === 'running' ? 'paused' : 'running'
      }).then(function () {
        Timer.toggleTimerStatus(_this.timer_id);
      });
    }
  }, {
    key: "$saveAsAnEntry",
    value: function $saveAsAnEntry(data) {
      var _this2 = this;

      if (!data.phase_id && data.task_id) {
        data.phase_id = data.task_id;
      }

      return Vue.prototype.$axios.post('/timers/' + this.timer_id + '/save-as-an-entry', data).then(function (response) {
        Vue.prototype.$eventHub.$emit('entry-changed', response.data);
        Timer.delete(_this2.timer_id);
        Entry.insertOrUpdate({
          data: response.data
        });
        Timer.$getOldTimersCount();
      });
    }
  }, {
    key: "$delete",
    value: function $delete() {
      return Timer.api().delete('/timers/' + this.timer_id, {
        delete: this.timer_id
      }).then(function () {
        Timer.$getOldTimersCount();
      });
    }
  }], [{
    key: "apiConfig",
    get: // This is the name used as module name of the Vuex Store.
    function get() {
      return {
        dataKey: 'data'
      };
    }
  }, {
    key: "fields",
    value: // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    function fields() {
      return {
        timer_id: this.attr(null),
        client_id: this.attr(-1),
        project_id: this.attr(null),
        project: this.belongsTo(Project, 'project_id'),
        account: this.belongsTo(Account, 'account_id', 'account_id'),
        account_id: this.attr(null),
        user_id: this.attr(null),
        user: this.belongsTo(User, 'user_id'),
        task_id: this.attr(null),
        phase: this.belongsTo(Phase, 'task_id'),
        timer_status: this.attr(null),
        seconds: this.attr(null),
        notes: this.attr(null),
        timer_date: this.attr(null),
        date: this.attr(null),
        timer_start: this.attr(null),
        time_from: this.attr(null),
        platform: this.attr(null),
        source: this.attr(null),
        source_text: this.attr(null),
        source_url: this.attr(null),
        source_id: this.attr(null),
        source_data: this.attr(null),
        todo_id: this.number(null).nullable(),
        todo: this.belongsTo(Todo, 'todo_id', 'todo_id'),
        tags: this.belongsToMany(Tag, TimerTag, 'timer_id', 'tag_id'),
        tag_ids: this.attr(null)
      };
    }
  }, {
    key: "$getOldTimersCount",
    value: function $getOldTimersCount() {
      Vue.prototype.$axios.get('/timers', {
        params: {
          date_to: moment().subtract(1, 'day').format('YYYY-MM-DD'),
          per_page: 1
        }
      }).then(function (response) {
        Timer.commit(function (state) {
          state.oldTimersCount = response.data.total;
        });
      }).catch(function () {});
    }
  }, {
    key: "toggleTimerStatus",
    value: function toggleTimerStatus(timerId) {
      var runningTimers = Timer.query().where('timer_status', 'running').where(function (timer) {
        return timer.timer_id !== timerId;
      }).get();
      runningTimers.forEach(function (timer) {
        Timer.update({
          where: timer.timer_id,
          data: {
            timer_status: 'paused'
          }
        });
      });
    }
  }, {
    key: "updateRunningTimer",
    value: function updateRunningTimer() {
      if (!Timer.state.interval) {
        Timer.state.interval = setInterval(function () {
          var runningTimer = Timer.query().where('timer_status', 'running').last();

          if (runningTimer) {
            Timer.update({
              where: runningTimer.timer_id,
              data: {
                seconds: runningTimer.seconds + moment.utc().diff(moment.utc(runningTimer.timer_start), 'seconds'),
                timer_start: moment().format()
              }
            });
          }
        }, 10000);
      }
    }
  }]);

  return Timer;
}(VuexORM.Model);

_defineProperty(Timer, "entity", 'timers');

_defineProperty(Timer, "primaryKey", 'timer_id');

_defineProperty(Timer, "state", {
  interval: null,
  pending: false,
  lastSync: null,
  oldTimersCount: 0
});

export { Timer as default };